/* eslint-disable */
import { Switch, Route, Redirect } from "react-router-dom";
import { protectedRoutes, publicRoutes } from "./Routes";

const Authmiddleware = () => {
  const token = localStorage.getItem("token"); // token is null if user is not logged in.

  return (
    <Switch>
      {/* Render all routes */}
      {(token ? protectedRoutes : publicRoutes).map((route) => (
        <Route
          key={route.path}
          path={route.path}
          exact
          render={(props) => {
            const Component = route.component;
            return <Component {...props} />;
          }}
        />
      ))}

      {/* Default redirects */}
      <Redirect to={token ? "/admin/dashboard" : "/"} />
    </Switch>
  );
};

export default Authmiddleware;
